import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent {
  @Input({ required: true }) public maxLength: number;
  @Input({ required: true }) public isFieldInvalid: boolean;
  @Input({ required: true }) public dataTestId: string;
  @Input({ required: true }) public valueLength: number;
}
